import { MapPin, Phone, Mail, Globe, ArrowUpRight, Heart } from "lucide-react";

const quickLinks = [
  { name: "Özellikler", href: "#features" },
  { name: "Modüller", href: "#modules" },
  { name: "Nasıl Çalışır", href: "#how-it-works" },
  { name: "Faydalar", href: "#benefits" },
  { name: "Görseller", href: "#screenshots" },
  // { name: "Referanslar", href: "#testimonials" },
];

const techStack = [
  "AI Konuşma Tanıma",
  "SNOMED CT & ICD-10",
  "FastAPI & WebSocket",
  "Flutter Mobil",
  "Docker & NGINX",
];

export default function Footer() {
  return (
    <footer className="relative bg-navy-900 dark:bg-navy-950 text-white overflow-hidden">
      {/* Top gradient border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/50 to-transparent" />

      {/* Background mesh */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary-600/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-medical-blue/10 rounded-full blur-3xl" />
      </div>

      <div className="section-container relative z-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-5">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-medical-blue rounded-xl flex items-center justify-center shadow-glow-primary">
                <span className="text-white font-bold text-lg">MV</span>
              </div>
              <div>
                <div className="font-display font-bold text-lg">MultiVision</div>
                <div className="text-[10px] font-semibold text-primary-400 uppercase tracking-premium -mt-0.5">
                  Report
                </div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Yapay zeka destekli tıbbi görüntüleme raporlaması ile sağlık sektöründe
              verimliliği artırıyor, insan hatalarını azaltıyoruz.
            </p>
            <div className="text-xs text-gray-500">
              <p className="font-semibold text-gray-300 mb-1">
                YAKAZA Bilişim Çözümleri
              </p>
              <p>Danışmanlık Ltd. Şti.</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-premium text-gray-300 mb-5">
              Hızlı Erişim
            </h3>
            <div className="space-y-2.5">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="group flex items-center text-sm text-gray-400 hover:text-primary-400 transition-colors duration-200"
                >
                  <span>{link.name}</span>
                  <ArrowUpRight
                    size={12}
                    className="ml-1 opacity-0 -translate-y-0.5 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200"
                  />
                </a>
              ))}
            </div>
          </div>

          {/* Tech Stack */}
          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-premium text-gray-300 mb-5">
              Teknolojiler
            </h3>
            <div className="flex flex-wrap gap-2">
              {techStack.map((tech) => (
                <span
                  key={tech}
                  className="px-2.5 py-1 text-xs font-medium rounded-lg bg-white/5 border border-white/10 text-gray-400"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display font-semibold text-sm uppercase tracking-premium text-gray-300 mb-5">
              İletişim
            </h3>
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-start space-x-3">
                <MapPin size={14} className="mt-1 text-primary-400 flex-shrink-0" />
                <div className="text-xs leading-relaxed">
                  <p>Üniversiteler Mah. 1606. Cd.</p>
                  <p>Cyberpark, Cyberplaza A Blok Z05</p>
                  <p>Bilkent 06800 Çankaya/ANKARA</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={14} className="text-primary-400 flex-shrink-0" />
                <span className="text-xs">0-312-295-6485</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={14} className="text-primary-400 flex-shrink-0" />
                <a
                  href="mailto:multivision@yakaza.com.tr"
                  className="text-xs hover:text-primary-400 transition-colors"
                >
                  multivision@yakaza.com.tr
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Globe size={14} className="text-primary-400 flex-shrink-0" />
                <a
                  href="https://www.yakaza.com.tr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs hover:text-primary-400 transition-colors"
                >
                  www.yakaza.com.tr
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p>© 2024 YAKAZA Bilişim Çözümleri. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-1.5">
            <span>KVKK & ISO 27001 & ISO 27799 & OWASP uyumlu</span>
            <Heart size={10} className="text-primary-500" />
          </div>
        </div>
      </div>
    </footer>
  );
}
